/**
 * Scan to Print: My QR shows a short-lived token the app swaps every 60 seconds
 * and the API accepts for 75
 * after minting; a vendor scanner redeems it for the member's print details.
 * Spec: church-systems-docs `HOGC One/Scan to Print/README.md`.
 */

// The string is the contract with hogc-one-api (SCAN_PRINT_FLAG). It gates the
// token route there and the token QR here.
export const SCAN_PRINT_FLAG = 'scan-print';

/** Used only if the API leaves out `refreshAfterSeconds`; the API sends 60 today. */
export const QR_TOKEN_DEFAULT_REFRESH_SECONDS = 60;

/** After a failed fetch (offline, a dropped request), try again this soon on its own. */
export const QR_TOKEN_RETRY_MS = 5000;

/**
 * After a 429, wait out the API's window instead: it allows 20 tokens a minute
 * per member and answers "try again in a minute". The short retry kept a
 * limited member limited (12 asks a minute per open My QR).
 */
export const QR_TOKEN_RATE_LIMITED_RETRY_MS = 60_000;
